import { DeleteOutline } from '@mui/icons-material'
import { projectSelectors } from 'features/BillOfMaterials/store/selectors/projectSelectors'
import { useBomItemDetailsDialog } from 'features/BomItemDetailsDialog/useBomItemDetailsDialog'
import { isEqual } from 'lodash'
import { BomItemPointer } from 'model/Project/BomItemPointer'
import { useCallback } from 'react'
import { useLocation } from 'react-router'
import { useAppSelector } from 'store/configureStore'
import { deleteBoMItem } from '../../store/asyncActions/deleteBoMItem'
import { BomItemMenuItem } from './BomItemMenuItem'

export const DeleteMenuItem = ({
  bomItemPointer,
  onClose,
}: {
  bomItemPointer: BomItemPointer
  onClose?: () => void
}) => {
  const openDetails = useBomItemDetailsDialog()

  const { search } = useLocation()

  const previousBomItemPointer = useAppSelector((state) => {
    const pointers =
      projectSelectors.previousAndNextBomItemIdsSelector(bomItemPointer)(state)
    return pointers?.previousBomItemPointer
  }, isEqual)

  const onDeleteCallback = useCallback(() => {
    if (search.includes('bomItemId') && previousBomItemPointer) {
      openDetails(null, { bomItemPointer: previousBomItemPointer })
    }
  }, [openDetails, previousBomItemPointer, search])

  return (
    <BomItemMenuItem
      // disableIfNotEditable
      action={deleteBoMItem}
      actionParams={{
        bomItemPointer: bomItemPointer,
        onDeleted: onDeleteCallback,
      }}
      primaryTextTranslationKey="project:delete-item"
      secondaryTextTranslationKey="project:delete-item-description"
      icon={<DeleteOutline />}
      onClose={onClose}
      closeOnClick
    />
  )
}
